import React from 'react';

import { FormSeparator } from '@/components/ui/FormSeparator';
import { OAUTH_PROVIDERS } from '@/features/auth/login/consts/oauth';
import type { Strategy } from '@/features/auth/login/types/login';

interface SocialButtonsProps {
  onLogin: (strategy: Strategy) => void;
  providers?: typeof OAUTH_PROVIDERS;
}

export const SocialButtons: React.FC<SocialButtonsProps> = ({ onLogin, providers = OAUTH_PROVIDERS }) => {
  return (
    <div className="py-6">
      <FormSeparator text="WITH" widthClass="w-32" />
      <div className="flex justify-center gap-3 py-6">
        {providers.map(({ name, icon, strategy }) => (
          <button
            key={name}
            type="button"
            onClick={() => {
              onLogin(strategy);
            }}
            aria-label={`Sign in with ${name}`}
            className="border-border-100 flex h-20 w-20 cursor-pointer flex-col items-center justify-center gap-1 rounded-md border shadow-sm transition-all duration-200 hover:shadow-[0_6px_18px_rgba(0,0,0,0.22)]"
          >
            <img src={icon} alt={name} className="h-6 w-6" />
            <div className="text-typography-900/65">{name}</div>
          </button>
        ))}
      </div>
      <FormSeparator text="OR" widthClass="w-32" />
    </div>
  );
};
